import ResourceSvc from '@/services/resource.svc.js';
import { EventBus } from '@/services/Event.js';
import { Popover } from 'element-ui';
import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import DateTimeAnswer from '@/components/shared/answer-types/datetime/datetime.vue';
import NumberAnswer from '@/components/shared/answer-types/number/number.vue';
import CheckBoxAnswer from '@/components/shared/answer-types/checkbox/checkbox.vue';
import VueToggles from 'vue-toggles';

const request = new ResourceSvc();

export default {
  name: 'RaceCoupon',
  props: {
    id: [Number, String],
  },
  components: {
    [Popover.name]: Popover,
    'text-answer': TextAnswer,
    'date-time-answer': DateTimeAnswer,
    'number-answer': NumberAnswer,
    'checkbox-answer': CheckBoxAnswer,
    VueToggles: VueToggles,
  },
  computed: {
    total() {
      return this.coupons.length;
    },
    test() {
      return this.newCoupon;
    },
  },
  data() {
    return {
      addNewMode: false,
      isProcessing: false,
      newCoupon: {},
      coupons: [],
    };
  },
  methods: {
    showWarning(message) {
      if (!message) {
        message = 'Warning!';
      }
      this.$notify({
        message: message,
        type: 'warning',
        timeout: 5000,
      });
    },
    showSuccess(message) {
      if (!message) {
        message = 'Operation success!';
      }

      this.$notify({
        message: message,
        type: 'success',
        timeout: 1000,
      });
    },
    console(message) {
      if (console && console.log) {
        if (message) {
          console.log(message);
        } else {
          var date = new Date();
          console.log(
            '-------> ' + date.getMinutes() + ':' + date.getSeconds()
          );
        }
      }
    },
    isIndividual: function () {
      var self = this;
      self.newCoupon.isIndividual = !self.newCoupon.isIndividual;
      self.$forceUpdate();
    },
    isRelay: function () {
      var self = this;
      self.newCoupon.isRelay = !self.newCoupon.isRelay;
      self.$forceUpdate();
    },
    init() {
      var self = this;
      EventBus.$off(
        `update-visibility-field-id-newCoupon.isAmountOrPercentage`
      );
      EventBus.$on(
        `update-visibility-field-id-newCoupon.isAmountOrPercentage`,
        currentValue => {
          self.newCoupon.hiddenPercentage = currentValue == 1;
          self.newCoupon.hiddenAmount = currentValue == 0;

          if (self.newCoupon.hiddenAmount) {
            self.newCoupon.discountAmount = null;
            self.newCoupon.isValidDiscountAmount = false;
          } else {
            self.newCoupon.discountAmount = 1;
            self.newCoupon.isValidDiscountAmount = true;
          }
          if (self.newCoupon.hiddenPercentage) {
            self.newCoupon.discountPercentage = null;
            self.newCoupon.isValidDiscountPercentage = false;
          } else {
            self.newCoupon.discountPercentage = 1;
            self.newCoupon.isValidDiscountPercentage = true;
          }
          self.$forceUpdate();
        }
      );

      EventBus.$off(`update-visibility-field-id-newCoupon.isExpired`);
      EventBus.$on(
        `update-visibility-field-id-newCoupon.isExpired`,
        currentValue => {
          self.newCoupon.hiddenExpiredDate = currentValue == 0;
          if (self.newCoupon.hiddenExpiredDate) {
            self.newCoupon.expiryDate = null;
          }
          self.$forceUpdate();
        }
      );

      EventBus.$off(`update-visibility-field-id-newCoupon.isLimited`);
      EventBus.$on(
        `update-visibility-field-id-newCoupon.isLimited`,
        currentValue => {
          self.newCoupon.hiddenNumberOfUses = currentValue == 0;
          if (self.newCoupon.hiddenNumberOfUses) {
            self.newCoupon.numberOfUses = null;
            self.newCoupon.isValidNumberOfUses = false;
          } else {
            self.newCoupon.numberOfUses = 1;
            self.newCoupon.isValidNumberOfUses = true;
          }
          self.$forceUpdate();
        }
      );

      this.load();
    },
    cancel() {
      this.load();
    },
    load() {
      var self = this;
      self.isProcessing = true;
      request.getCoupons(self.id).then(
        response => {
          self.isProcessing = false;
          if (response && response.body && response.body.isSuccess) {
            if (response.body.outputData && response.body.outputData.length) {
              self.coupons = response.body.outputData;
              self.updateVisibility();
            } else {
              self.coupons = [];
            }
          } else {
            self.$showError();
          }
        },
        err => {
          self.isProcessing = false;
          self.$showError();
        }
      );
    },
    updateVisibility() {
      var self = this;
      if (self.coupons && self.coupons.length) {
        self.coupons.forEach((coupon, index) => {
          EventBus.$off(
            `update-visibility-field-id-couponAmountOrPercentage${index * 100}`
          );
          EventBus.$on(
            `update-visibility-field-id-couponAmountOrPercentage${index * 100}`,
            currentValue => {
              coupon.hiddenPercentage = currentValue == 1;
              coupon.hiddenAmount = currentValue == 0;

              if (coupon.hiddenAmount) {
                coupon.discountAmount = null;
                coupon.isValidDiscountAmount = false;
              } else {
                if (!coupon.discountAmount) {
                  coupon.discountAmount = 1;
                }
                coupon.isValidDiscountAmount = true;
              }
              if (coupon.hiddenPercentage) {
                coupon.discountPercentage = null;
                coupon.isValidDiscountPercentage = false;
              } else {
                if (!coupon.discountPercentage) {
                  coupon.discountPercentage = 1;
                }
                coupon.isValidDiscountPercentage = true;
              }
              self.$forceUpdate();
            }
          );

          EventBus.$off(
            `update-visibility-field-id-couponIsExpired${index * 100}`
          );
          EventBus.$on(
            `update-visibility-field-id-couponIsExpired${index * 100}`,
            currentValue => {
              coupon.hiddenExpiredDate = currentValue == 0;
              if (coupon.hiddenExpiredDate) {
                coupon.expiryDate = null;
              }
              self.$forceUpdate();
            }
          );

          EventBus.$off(
            `update-visibility-field-id-couponIsLimited${index * 100}`
          );
          EventBus.$on(
            `update-visibility-field-id-couponIsLimited${index * 100}`,
            currentValue => {
              coupon.hiddenNumberOfUses = currentValue == 0;
              if (coupon.hiddenNumberOfUses) {
                coupon.numberOfUses = null;
                coupon.isValidNumberOfUses = false;
              } else {
                if (!coupon.numberOfUses) {
                  coupon.numberOfUses = 1;
                }
                coupon.isValidNumberOfUses = true;
              }
              self.$forceUpdate();
            }
          );
        });
      }
    },
    save() {
      self = this;
      if (
        self.$refs.allCoupons.getElementsByClassName('popover-error').length
      ) {
        this.$showError('Please fix mistakes with red exclamation mark');
        return;
      }

      self.isProcessing = true;
      request.addOrUpdateCoupons(self.id, { coupons: self.coupons }).then(
        response => {
          self.isProcessing = false;
          if (response && response.body && response.body.isSuccess) {
            self.cancel();
          } else {
            if (response && response.body && response.body.message) {
              self.$showError(response.body.message);
            } else {
              self.$showError();
            }
          }
        },
        err => {
          self.isProcessing = false;
          self.$showError();
        }
      );
    },
    remove(id) {
      this.coupons = this.coupons.filter(x => x.id != id);
      this.updateVisibility();
    },
    add() {
      if (this.$refs.newCoupon.getElementsByClassName('popover-error').length) {
        this.$showError('Please fix mistakes with red exclamation mark');
      } else if (
        this.coupons.filter(x => x.code == this.newCoupon.code).length
      ) {
        this.$showError(
          "You can't add coupon with duplicated code. Please use another one."
        );
      } else {
        this.coupons.unshift({
          code: this.newCoupon.code,
          expiryDate: this.newCoupon.expiryDate,
          description: this.newCoupon.description,
          discountAmount: this.newCoupon.discountAmount,
          discountPercentage: this.newCoupon.discountPercentage,
          numberOfUses: this.newCoupon.numberOfUses,
          isExpiredDate: this.newCoupon.isExpiredDate,
          isAmountUsed: this.newCoupon.isAmountUsed,
          isLimited: this.newCoupon.isLimited,
          isIndividual: this.newCoupon.isIndividual,
          isRelay: this.newCoupon.isRelay,
        });
        this.updateVisibility();
        this.clearNewCoupon();
        this.addNewMode = false;
      }
    },
    clearNewCoupon() {
      this.newCoupon = {};
    },
  },
  mounted() {
    this.init();
    this.newCoupon.isIndividual = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-coupon/race-coupon.js